module.exports = __webpack_public_path__ + "img/box-with-coins.094f9f8b.png";